import { render, staticRenderFns } from "./FormCadCliente.vue?vue&type=template&id=8ef78e34&"
import script from "./FormCadCliente.vue?vue&type=script&lang=js&"
export * from "./FormCadCliente.vue?vue&type=script&lang=js&"
import style0 from "./FormCadCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormCadCliente.vue"
export default component.exports